import "./styles.scss";
import Logo from "./Logo";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import StyledOutlineButton from "../../components/Classroom/StyledOutlineButton";

export default function TutoriaHomePage() {
  const navigate = useNavigate();

  return (
    <div className="tutoria-homepage">
      {/* NAVBAR */}
      <header className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
        <div className="container py-2">
          <div>
            <Logo />
          </div>

          <div className="nav-item d-flex align-items-center gap-2 ms-3">
            <StyledOutlineButton
              btnText={"Create Account"}
              onClick={() => {
                navigate(`/register`);
              }}
            />
          </div>
        </div>
      </header>

      {/* HERO */}
      <section className="hero d-flex align-items-center">
        <div className="container text-center text-white">
          <h1 className="display-5 fw-bold">
            Unlock Your Potential with{" "}
            <span className="text-highlight">Tutoria</span>
          </h1>
          <p className="lead mt-3 mw-800 mx-auto">
            From standardized exams to international admissions — world-class
            video lectures, solved past papers, quizzes and expert counseling to
            help you reach your goals.
          </p>
          <div className="mt-4 d-flex justify-content-center gap-3 flex-wrap">
            <Button
              className="welcome-login-button"
              onClick={() => {
                navigate(`/login`);
              }}
            >
              Login
            </Button>
          </div>

          <div className="hero-cards row justify-content-center mt-5 g-3">
            <div className="col-10 col-md-6">
              <div className="card hero-mini p-3 shadow-sm">
                <div className="card-body text-start">
                  <h6 className="fw-bold">Tutoria (Test Prep)</h6>
                  <p className="mb-1 small text-muted">
                    SAT, IELTS, GRE, GMAT, MDCAT, ECAT — test prep, mock exams &
                    admissions counseling.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section id="why" className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center fw-bold">Why Choose Tutoria?</h2>
          <p className="text-center text-muted mb-4">
            Designed to develop confidence, critical thinking and
            exam-readiness.
          </p>

          <div className="row g-4">
            {features.map((f, i) => (
              <div className="col-sm-6 col-md-3" key={i}>
                <div className="card text-center h-100 feature-card p-3 shadow-sm">
                  <div className="feature-icon">{f.icon}</div>
                  <div className="card-body">
                    <h5 className="card-title fw-bold">{f.title}</h5>
                    <p className="card-text small text-muted">{f.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MOTIVATIONAL BANNER */}
      <section className="py-5 text-center text-white motivational-banner">
        <div className="container">
          <h3 className="fw-bold">
            “Education is the most powerful weapon which you can use to change
            the world.”
          </h3>
          <p className="mt-3">
            Start your learning journey today with Tutoria — structured,
            supportive, and student-first.
          </p>
          <button
            className="btn btn-lg btn-light mt-3"
            onClick={() => {
              navigate(`/register`);
            }}
          >
            Join Now
          </button>
        </div>
      </section>
    </div>
  );
}

/* ---------- Helper data & components inside same file for convenience ---------- */

const features = [
  {
    icon: "🎓",
    title: "Expert Mentors",
    desc: "Learn from experienced teachers and personalized guidance.",
  },
  {
    icon: "📚",
    title: "Comprehensive Content",
    desc: "Video lectures, solved papers, notes and quizzes.",
  },
  {
    icon: "🧠",
    title: "Critical Thinking",
    desc: "Assignments & mock exams develop reasoning skills.",
  },
  {
    icon: "🚀",
    title: "Goal Oriented",
    desc: "Structured plans for standardized and international tests.",
  },
];
